import React, { PropsWithChildren, useState } from 'react';
import { HashRouter } from 'react-router-dom';
import { trackPageView } from '@unifocus/js-utils';

const usePageViews = () => {
   const [trackLocation, setTrackLocation] = useState(window.location);

   React.useEffect(() => {
      trackPageView(window.location.pathname + window.location.search + window.location.hash);
      setTrackLocation(window.location);
   }, [trackLocation.pathname, trackLocation.search, trackLocation.hash]);
};

export const getBaseHash = (): string => {
   const hash = window.location.hash;
   const hashParamIndex = hash.indexOf('/', hash.indexOf('/') + 1);

   if (hashParamIndex > 0) {
      return hash.substring(1, hashParamIndex);
   }

   return hash.substring(1);
};

export const Router = (props: PropsWithChildren<any>) => {
   usePageViews();

   return (
      <HashRouter>
         {props.children}
      </HashRouter>
   );
};
